/* Premium 3D color swatches — Shain Pro
   Drives the theme's existing [data-variant-selects] picker so price, media,
   add to cart and the "Bundle & save" block stay in sync. */
(function () {
  if (window.customElements.get('color-swatch-premium')) return;

  class ColorSwatchPremium extends HTMLElement {
    constructor() {
      super();
      this.onInputChange = this.onInputChange.bind(this);
      this.onExternalChange = this.onExternalChange.bind(this);
      this.onAnimationEnd = this.onAnimationEnd.bind(this);
    }

    connectedCallback() {
      this.optionIndex = parseInt(this.dataset.optionIndex, 10) || 0;
      this.root = this.closest('.shopify-section') || document;
      this.cachedVariants = null;

      this.addEventListener('change', this.onInputChange);
      this.addEventListener('animationend', this.onAnimationEnd);
      document.addEventListener('change', this.onExternalChange);

      this.syncFromSelect();
      this.updateAvailability();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onInputChange);
      this.removeEventListener('animationend', this.onAnimationEnd);
      document.removeEventListener('change', this.onExternalChange);
    }

    get inputs() {
      return Array.prototype.slice.call(this.querySelectorAll('[data-csp-input]'));
    }

    get container() {
      return this.root.querySelector('[data-variant-selects]');
    }

    get select() {
      var container = this.container;
      if (!container) return null;
      return container.querySelector('[data-variant-option][data-option-index="' + this.optionIndex + '"]');
    }

    getVariants() {
      if (this.cachedVariants) return this.cachedVariants;
      var script = this.root.querySelector('[data-variant-data]');
      if (!script) return [];
      try {
        this.cachedVariants = JSON.parse(script.textContent);
      } catch (error) {
        this.cachedVariants = [];
      }
      return this.cachedVariants;
    }

    getSelectedOptions() {
      var container = this.container;
      if (!container) return [];
      return Array.prototype.map.call(container.querySelectorAll('[data-variant-option]'), function (select) {
        return select.value;
      });
    }

    onInputChange(event) {
      var input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.hasAttribute('data-csp-input')) return;

      this.setLabel(input.value);
      this.pop(input);

      var select = this.select;
      if (select) {
        if (select.value !== input.value) {
          select.value = input.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      this.updateVariantInputDirectly(input.value);
    }

    updateVariantInputDirectly(value) {
      var variants = this.getVariants();
      var selected = this.getSelectedOptions();
      var index = this.optionIndex;

      var match = variants.filter(function (variant) {
        return variant.options.every(function (option, i) {
          if (i === index) return option === value;
          return selected[i] === undefined || option === selected[i];
        });
      });
      var variant = match.filter(function (item) { return item.available; })[0] || match[0];
      if (!variant) return;

      var idInput = this.root.querySelector('[data-variant-id]');
      if (idInput && String(idInput.value) !== String(variant.id)) {
        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    onExternalChange(event) {
      var target = event.target;
      if (!(target instanceof Element) || !target.matches('[data-variant-option]')) return;
      if (!this.root.contains(target)) return;
      if (target === this.select) this.syncFromSelect();
      this.updateAvailability();
    }

    syncFromSelect() {
      var select = this.select;
      if (!select) return;
      var value = select.value;
      this.inputs.forEach(function (input) {
        if (input.value === value && !input.checked) input.checked = true;
      });
      this.setLabel(value);
    }

    setLabel(value) {
      var label = this.querySelector('[data-csp-selected]');
      if (label) label.textContent = value;
    }

    updateAvailability() {
      var variants = this.getVariants();
      if (!variants.length) return;
      var selected = this.getSelectedOptions();
      var index = this.optionIndex;

      this.inputs.forEach(function (input) {
        var available = variants.some(function (variant) {
          if (!variant.available) return false;
          return variant.options.every(function (option, i) {
            if (i === index) return option === input.value;
            return selected[i] === undefined || option === selected[i];
          });
        });
        var item = input.closest('.csp__item');
        if (item) item.classList.toggle('is-unavailable', !available);
      });
    }

    pop(input) {
      var item = input.closest('.csp__item');
      if (!item) return;
      item.classList.remove('is-popping');
      void item.offsetWidth;
      item.classList.add('is-popping');
    }

    onAnimationEnd(event) {
      if (event.animationName !== 'csp-pop') return;
      var item = event.target.closest('.csp__item');
      if (item) item.classList.remove('is-popping');
    }
  }

  if (!window.customElements.get('color-swatch-premium')) {
    window.customElements.define('color-swatch-premium', ColorSwatchPremium);
  }
})();
